import * as React from "react"

const SvgPanelClose = (props) => (
    <svg
        width={10}
        height={10}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="m5.968 5 2.954-2.948a.69.69 0 0 0-.975-.975L5 4.031 2.053 1.077a.69.69 0 1 0-.975.975L4.032 5 1.078 7.946a.687.687 0 0 0 .224 1.126.687.687 0 0 0 .751-.15L5 5.968l2.947 2.954a.687.687 0 0 0 1.125-.224.687.687 0 0 0-.15-.752L5.968 5Z"
            fill="#015CD1"
        />
    </svg>
)

export default SvgPanelClose
